import React, { useState } from "react";

const EnvelopeIcon = ({ dmsType }: { dmsType: number }) => {
  const [isHovered, setIsHovered] = useState(false);
  const styles = {
    buttonContainer: {
      height: "60px",
      width: "60px",
    },
    buttonContent: {
      right: "0px",
      top: "0px",
      height: "4.285714285714286em",
      width: "4.285714285714286em",
    },
    svgStyle: {
      height: "4.285714285714286em",
      width: "4.285714285714286em",
    },
    designstudioCircle: {
      filter: "url(#dropshadow)",
      WebkitFilter: "url(#dropshadow)",
    },
    designstudioContainer: {
      opacity: isHovered ? 0.6 : 1,
      transition: "opacity .5s ease-out",
    },
  };

  return (
    <div
      id="iframe-button-container"
      style={styles.buttonContainer}
      onClick={() => {
        if (dmsType === 0) {
          window.open(
            "https://idealsoftware.na3.teamsupport.com/createticket",
            "_blank"
          );
        } else {
          window.open(
            "https://infinity.na3.teamsupport.com/createticket",
            "_blank"
          );
        }
      }}
    >
      <div
        id="iframe-button-content"
        style={{
          right: "5px",
          bottom: "10px",
          height: "4.285em",
          width: "4.285em",
          position: "fixed",
          fontSize: "0.8rem",
        }}
      >
        <div id="svg-container">
          <svg viewBox="0 0 600 600">
            <defs>
              <filter id="dropshadow" height="140%">
                <feGaussianBlur in="SourceAlpha" stdDeviation="15" />
                <feOffset result="offsetblur" dx="10" dy="10" />
                <feComponentTransfer>
                  <feFuncA type="linear" slope="0.8" />
                </feComponentTransfer>
                <feMerge>
                  <feMergeNode />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
            <g
              id="envelope"
              style={styles.designstudioContainer}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <circle
                className="designstudio-circle"
                cx="50%"
                cy="50%"
                r="260"
                fill="#3498db"
                stroke="#ffffff"
                strokeWidth="0"
                fillOpacity="1"
                strokeLinejoin="round"
                style={styles.designstudioCircle}
              />
              <path
                className="designstudio-icon"
                fill="#ffffff"
                d="M1792 826v-794q0 -66 -47 -113t-113 -47h-1472q-66 0 -113 47t-47 113v794q44 -49 101 -87q362 -246 497 -345q57 -42 92.5 -65.5t94.5 -48t110 -24.5h1h1q51 0 110 24.5t94.5 48t92.5 65.5q170 123 498 345q57 39 100 87zM1792 1120q0 -79 -49 -151t-122 -123 q-376 -261 -468 -325q-10 -7 -42.5 -30.5t-54 -38t-52 -32.5t-57.5 -27t-50 -9h-1h-1q-23 0 -50 9t-57.5 27t-52 32.5t-54 38t-42.5 30.5q-91 64 -262 182.5t-205 142.5q-62 42 -117 115.5t-55 136.5q0 78 41.5 130t118.5 52h1472q65 0 112.5 -47t47.5 -113z"
                transform="scale(.175, -.175) translate(800, -2250)"
              />
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default EnvelopeIcon;
